import React from 'react';
import { Check } from 'lucide-react';
import { clsx } from 'clsx';

export interface CheckboxProps {
  checked: boolean;
  onClick: (e: React.MouseEvent) => void;
  className?: string;
}

/**
 * Geteilte Auswahl-Checkbox (role=checkbox). Genutzt von der mobilen
 * Beleg-Positionsauswahl und der Desktop-Positionstabelle, damit beide
 * Pfade exakt dasselbe Bedienelement teilen.
 */
export function Checkbox({ checked, onClick, className }: CheckboxProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      role="checkbox"
      aria-checked={checked}
      className={clsx(
        'w-5 h-5 rounded border-2 grid place-items-center shrink-0 transition-colors',
        checked
          ? 'bg-primary border-primary text-white'
          : 'bg-white border-gray-300 text-transparent',
        className
      )}
    >
      <Check size={12} strokeWidth={3} />
    </button>
  );
}
